jQuery(document).on('ready js_event_wpv_pagination_completed js_event_wpv_parametric_search_form_updated', function () {
    jQuery('.wm-products__filtersGenders').find(':checked').parent().addClass('-checked');
});
